'use client';

import { usePathname } from 'next/navigation';

import { normalisePath } from '@core/Utils/Url/NormalisePath';
import { PrefetchLink } from '@shared-components/PrefetchLink/PrefetchLink';

import type { OptionalPageBuilderProps } from '../../Entities/PageBuilder.entity';
import type { SimplifiedSideNavigation } from './SideNavigation.entity';

import styles from './SideNavigation.module.css';

export const SideNavigation = ({ links }: OptionalPageBuilderProps<SimplifiedSideNavigation>) => {
  const items = links ?? [];
  const pathname = usePathname();
  const currentPath = pathname ? normalisePath(pathname) : '';

  if (items.length === 0) return null;

  return (
    <nav className={styles.navigation} aria-label="Related pages">
      <ul className={styles.list}>
        {items.map((item, index) => {
          const hrefPath = new URL(item.url).pathname;
          const isCurrent = normalisePath(hrefPath) === currentPath;

          return (
            <li key={`${item.label ?? 'link'}-${index}`}>
              <PrefetchLink
                href={item.url}
                className={styles.link}
                data-selected={isCurrent || undefined}
                aria-current={isCurrent ? 'page' : undefined}
                rel={item.noFollow ? 'nofollow' : undefined}
              >
                {item.label}
              </PrefetchLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

SideNavigation.displayName = 'SideNavigation';
